export default __webpack_public_path__ + "static/media/hiring.6a96e851.jpg";